var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSampleBale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M3.90286 1.73442L12.4035 5.48272L9 6.98417L0.548759 3.25595C0.738787 3.05555 0.971516 2.89493 1.23625 2.79012L3.90286 1.73442ZM5.62332 1.05329L7.61537 0.264638C8.50663 -0.0882125 9.49337 -0.0882129 10.3846 0.264638L16.7637 2.79012C17.0285 2.89493 17.2612 3.05555 17.4512 3.25595L14.0357 4.76268L5.62332 1.05329ZM17.9916 4.45742L9.64286 8.14043V18C9.89459 17.9562 10.1431 17.8865 10.3846 17.7909L16.7637 15.2654C17.5085 14.9705 18 14.234 18 13.4126V4.64296C18 4.58057 17.9972 4.51867 17.9916 4.45742ZM8.35714 18V8.14043L0.00840055 4.45742C0.00283496 4.51867 0 4.58057 0 4.64296V13.4126C0 14.234 0.491457 14.9705 1.23626 15.2654L7.61537 17.7909C7.85688 17.8865 8.10541 17.9562 8.35714 18Z",
    fill: "#222729"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSampleBale);
export default __webpack_public_path__ + "static/media/icon-sample-bale.cbeffec2a3a4826a30479eae2a16e9a1.svg";
export { ForwardRef as ReactComponent };